module.exports = __webpack_public_path__ + "static/media/Done.159ab642.svg";